<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Product opties" />
        </template>

        <template #pageContent>
            <div class="flex justify-between">
                <TableSearch tableId="configuration-product-attributes" :values="productAttributes" placeholder="Zoeken"/>

                <Modal buttonText="Toevoegen" buttonClass="add" @modalClosed="modalClosed" ref="modal">
                    <h2>Product optie {{ modalTitleAction }}</h2>
                    <Form @submitted="handleSubmit" class="w-full">
                        <Input type="hidden" name="id" v-model="form.id" />
                        <Select
                            label="Categorie"
                            name="assignment_type_id"
                            :options="assignmentTypes"
                            v-model="form.assignment_type_id"
                            :error="form.errors.assignment_type_id"
                        />
                        <Select
                            label="Webshop/partner"
                            name="webshop_id"
                            :required="true"
                            :options="webshops"
                            v-model="form.webshop_id"
                            :error="form.errors.webshop_id"
                        />
                        <Input type="text" label="Type (slug)" name="type" :required="true" v-model="form.type" :error="form.errors.type" />
                        <h3>Webshop label</h3>
                        <Input type="text" label="Beschrijving" name="description" :required="true" v-model="form.description" :error="form.errors.description" />

                        <h3>Webshop veld id</h3>
                        <Input type="text" label="NL" name="field_id_nl" :required="true" v-model="form.field_id_nl" :error="form.errors.field_id_nl" />
                        <Input type="text" label="FR" name="field_id_fr" :required="true" v-model="form.field_id_fr" :error="form.errors.field_id_fr" />
                        <Input type="text" label="EN" name="field_id_en" :required="true" v-model="form.field_id_en" :error="form.errors.field_id_en" />

                        <div class="inline-block self-end mt-4">
                            <Button text="Annuleren" buttonClass="secondary" data-modal="close" />
                            <Button
                                :text="modalTitleAction"
                                buttonType="submit"
                                buttonClass="save"
                                class="capitalize"
                                :loading="form.processing"
                            />
                        </div>
                    </Form>
                </Modal>
            </div>

            <Table id="configuration-product-attributes" :values="productAttributes">
                <thead>
                    <tr>
                        <Th :sort="false" :colspan="4"></Th>
                        <Th :sort="false" :colspan="3">Webshop veld id</Th>
                        <Th :sort="false"></Th>
                    </tr>
                    <tr>
                        <Th id="assignment_type.name">Type opdracht</th>
                        <Th id="webshop.code">Webshop/partner</Th>
                        <Th id="type">Type</th>
                        <Th id="description">Beschrijving</th>
                        <Th id="field_id_nl">NL</th>
                        <Th id="field_id_fr">FR</th>
                        <Th id="field_id_en">EN</th>
                        <Th :sort="false" class="w-[75px]"></Th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(productAttribute, key) in state.sortedValues['configuration-product-attributes']" :key="key">
                    <Td>{{ productAttribute.assignment_type.name }}</Td>
                    <Td>
                        {{ productAttribute.webshop.code.charAt(0).toUpperCase() + productAttribute.webshop.code.slice(1) }}
                    </Td>
                    <Td>{{ productAttribute.type }}</Td>
                    <Td>{{ productAttribute.description }}</Td>
                    <Td>{{ productAttribute.field_id_nl }}</Td>
                    <Td>{{ productAttribute.field_id_fr }}</Td>
                    <Td>{{ productAttribute.field_id_en }}</Td>
                    <Td>
                        <Button buttonClass="edit" size="small" title="Bewerken" @click="updateProductAttribute(productAttribute)" />
                        <Button buttonClass="delete" size="small" title="Verwijderen" @click="deleteProductAttribute(productAttribute)" />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import { useForm } from "@inertiajs/inertia-vue3"
import { ref } from "vue"
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Form,
        Input,
        Select,
    },
    props: [
        'productAttributes',
        'assignmentTypes',
        'webshops',
    ],
    setup (props)
    {
        let modalTitleAction = ref('toevoegen') //of bewerken
        const modal = ref(null)

        const form = useForm({
            id: null,
            assignment_type_id: null,
            webshop_id: null,
            type: null,
            description: null,
            field_id_nl: null,
            field_id_fr: null,
            field_id_en: null,
        });

        function updateProductAttribute(productAttribute)
        {
            form.id = productAttribute.id
            form.assignment_type_id = productAttribute.assignment_type_id
            form.webshop_id = productAttribute.webshop_id
            form.type = productAttribute.type
            form.description = productAttribute.description
            form.field_id_nl = productAttribute.field_id_nl
            form.field_id_fr = productAttribute.field_id_fr
            form.field_id_en = productAttribute.field_id_en

            modalTitleAction.value = 'bewerken'
            modal.value.show = true
        }

        function deleteProductAttribute(productAttribute)
        {
            if (!confirm('Bent u zeker dat u deze product optie wil verwijderen?'))
                return

            Inertia.delete('/configuration/assignment_types/product_attributes/' + productAttribute.id)
        }

        function handleSubmit()
        {
            if (modalTitleAction.value === 'toevoegen')
            {
                //Store
                form.post('/configuration/assignment_types/product_attributes', {
                    onSuccess: () => {
                        modal.value.show = false
                        modalClosed()
                    },
                })
            } else {
                //Update
                form.put('/configuration/assignment_types/product_attributes/' + form.id, {
                    onSuccess: () => {
                        modal.value.show = false
                        modalClosed()
                    },
                })
            }
        }

        function modalClosed()
        {
            form.clearErrors()
            form.reset()
            modalTitleAction.value = 'toevoegen'
        }

        return {
            state: store.state,
            ...store,
            form,
            handleSubmit,
            modal,
            modalClosed,
            modalTitleAction,
            updateProductAttribute,
            deleteProductAttribute,
        }
    },
}

</script>
